import { createContext } from "react";
import type { DashboardStore } from "../DashboardProvider.types";

const DashboardStoreContext = createContext<DashboardStore | undefined>(undefined);
DashboardStoreContext.displayName = "DashboardStoreContext";

export default DashboardStoreContext;
